// extracted by mini-css-extract-plugin
var _1 = "RatingListItemContent-modulehover__UZGYi";
var _2 = "RatingListItemContent-moduletext__oVwDm";
export { _1 as "hover", _2 as "text" }
